import { createSlice } from "@reduxjs/toolkit";
import {  fetchAIChatReportTableColumnNames, fetchAIChatReport } from "../thunks";
import { fetchAIChat, fetchAIClientUsers, updateChatFeedbackStatus, deleteAIChatReport } from "./thunk";

const initialState = {
  chatSession: [],
  humanCategories: [],
  clientUsers: [],
  tableColumnNames: [],
  chats: [],
  loading: false,
  headerLoading: false,
  updateChatFeedbackStatusLoading: false,
  clientUsersloading: false,
  categoryloading: false,
  chatloading: false,
  error: null,
};

const ChatReportSlice = createSlice({
  name: "aiChatReport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

    // Fetch Chat Report Table Column Names
    .addCase(fetchAIChatReportTableColumnNames.pending, (state) => {
        state.headerLoading = true;
        state.error = null;
    })
    .addCase(fetchAIChatReportTableColumnNames.fulfilled, (state, action) => {
        state.headerLoading = false;
        state.tableColumnNames = action.payload;
    })
    .addCase(fetchAIChatReportTableColumnNames.rejected, (state, action) => {
        state.headerLoading = false;
        state.error = action.payload;
    })


    .addCase(fetchAIChatReport.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchAIChatReport.fulfilled, (state, action) => {
        state.loading = false;
        state.chatSession = action.payload;
    })
    .addCase(fetchAIChatReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(fetchAIChat.pending, (state) => {
        state.chatloading = true;
        state.error = null;
    })
    .addCase(fetchAIChat.fulfilled, (state, action) => {
        state.chatloading = false;
        state.chats = action.payload;
    })
    .addCase(fetchAIChat.rejected, (state, action) => {
        state.chatloading = false;
        state.error = action.payload;
    })

    .addCase(fetchAIClientUsers.pending, (state) => {
        state.clientUsersloading = true;
        state.error = null;
    })
    .addCase(fetchAIClientUsers.fulfilled, (state, action) => {
        state.clientUsersloading = false;
        state.clientUsers = action.payload;
    })
    .addCase(fetchAIClientUsers.rejected, (state, action) => {
        state.clientUsersloading = false;
        state.error = action.payload;
    })

    .addCase(updateChatFeedbackStatus.pending, (state) => {
        state.updateChatFeedbackStatusLoading = true;
        state.error = null;
    })
    .addCase(updateChatFeedbackStatus.fulfilled, (state, action) => {
        state.updateChatFeedbackStatusLoading = false;
        const { ID, Status, Comment, Priority, PriorityType } = action.payload;
        state.chatSession = state.chatSession.map((item) =>
        item.ID == ID
            ? { ...item, Status, Comment, Priority, PriorityType }
            : item
        );
    })
    .addCase(updateChatFeedbackStatus.rejected, (state, action) => {
        state.updateChatFeedbackStatusLoading = false;
        state.error = action.payload;
    })

    .addCase(deleteAIChatReport.pending, (state) => {
        state.error = null;
    })
    .addCase(deleteAIChatReport.fulfilled, (state, action) => {
        const ids = action.payload.map((item) => item.ID);
        state.chatSession = state.chatSession.filter((item) => !ids.includes(item.ID));
    })
    .addCase(deleteAIChatReport.rejected, (state, action) => {
        state.error = action.payload;
    })
  },
});

export default ChatReportSlice.reducer;
